import React from 'react';
import { Box } from '@mui/material';
import OrderCustomerSnapshot from './OrderCustomerSnapshot';

export default function CustomerDetailsContainer({ order }) {
    return (
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
            <OrderCustomerSnapshot order={order} />
        </Box>
    );
}
